import DefaultValidation from "@/services/validations/DefaultValidation";
import { isNull } from "@/functions/Util";

export default class MoedaValidation extends DefaultValidation{
    validate(model, refs) {
        let validated = true;

        Object.entries(model).forEach(([key, value]) => {
            if(value!=null && typeof value == "string") model[key] = value.trim();
        });

        if (isNull(model.descricao)) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }

        if (isNull(model.simbolomonetario)) {
            refs.simboloMonetarioInput.focusedOut = true;
            validated = false;
        }

        if (isNull(model.idmoedaerp)) {
            refs.idErpInput.focusedOut = true;
            validated = false;
        }

        return validated;
    }
}